export enum Operator {
  AND = 'AND',
  OR = 'OR',
}
